import React, { useEffect } from "react";
import { useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const team = [
  // FIRST ROW
  {
    name: "Dr. Philip Ermita PIE, PDQM, ASEAN Engr.",
    role: "Director, Technology Business Incubation and Development Office",
    photo: "/images/team/drphilip.png",
  },
  {
    name: "Engr. Armando Victoria",
    role: "Chief, Startup Development Section",
    photo: "/images/team/2x2 1.png",
  },
  {
    name: "Mx. John Dee Gonos",
    role: "Chief, Incubation Management Section",
    photo: "/images/team/johndee.png",
  },
  {
    name: "Engr. Tristan Velardo",
    role: "Chief, Technology Development Section",
    photo: "/images/team/tristan.png",
  },
  {
    name: "Engr. Ma. Lourdes Girado",
    role: "PUP PYLON TBI Manager",
    photo: "/images/team/lourdes-1.png",
  },

  // SECOND ROW
  {
    name: "Engr. Kurt Leinard Balbuena",
    role: "Project Technical Assistant II",
    photo: "/images/team/kurt.png",
  },
  {
    name: "Mrs. Irma A. Gatcho",
    role: "Administrative Staff VI",
    photo: "/images/team/irma.png",
  },
  {
    name: "Mx. Pao Delos Santos",
    role: "Project Technical Assistant II",
    photo: "/images/team/lourdes.png",
  },
  {
    name: "Ms. Rodelaine Rodriguez",
    role: "Project Technical Assistant II",
    photo: "/images/team/kurt-1.png",
  },
  {
    name: "Mr. Kenneth Odgien",
    role: "Information Systems Researcher I",
    photo: "/images/team/Kenneth-1.png",
  },
  {
    name: "Mr. Erwin Esparto",
    role: "Information Systems Researcher I",
    photo: "/images/team/Erwin-1.png",
  },
];

export default function OurTeam() {
  useEffect(() => {
    AOS.init({ duration: 900, once: true });
  }, []);


const [copied, setCopied] = useState(false);

const handleCopy = async () => {
  try {
    await navigator.clipboard.writeText("tbido@pup.edu.ph");
    setCopied(true);

    setTimeout(() => {
      setCopied(false);
    }, 2000);
  } catch (error) {
    console.error("Copy failed:", error);
  }
};

  const firstRow = team.slice(0, 6);
  const secondRow = team.slice(6);

  return (
    <section className="w-full  bg-white flex flex-col items-center px-4 sm:px-6 md:px-8 lg:px-12 py-12 sm:py-16 md:py-20">
      {/* Heading */}
      <h1
        className="text-2xl sm:text-3xl md:text-3xl lg:text-3xl font-light text-gray-800 text-center"
        data-aos="fade-up"
      >
        The people behind{" "}
        <span
          className="font-bold text-transparent bg-clip-text"
          style={{
            backgroundImage:
              "linear-gradient(90deg, rgba(109,12,34,1), rgba(14,56,107,1))",
          }}
        >
          TBIDO
        </span>
      </h1>

      <p
        className="text-xs sm:text-sm md:text-base text-gray-600 text-center mt-2 sm:mt-3 md:mt-4 max-w-2xl"
        data-aos="fade-up"
        data-aos-delay="150"
      >
        Meet the team powering innovation and startup growth at TBIDO.
      </p>

      {/* FIRST ROW - Centered Grid */}
      <div
        className="mt-8 sm:mt-10 md:mt-12 flex justify-center w-full"
        data-aos="fade-up"
        data-aos-delay="250"
      >
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 sm:gap-6 md:gap-5 max-w-5xl">
          {firstRow.map((m) => (
            <div key={m.name} className="flex flex-col items-center text-center">
              <div className="bg-white rounded-xl shadow-md overflow-hidden">
                <img
                  src={m.photo}
                  alt={m.name}
                  className="w-32 h-32 sm:w-36 sm:h-36 md:w-40 md:h-40 lg:w-44 lg:h-44 object-cover"
                />
              </div>

              <h2 className="text-xs sm:text-sm md:text-xs tracking-tighter font-semibold text-gray-900 mt-3 leading-tight px-2">
                {m.name}
              </h2>

              <p className="text-xs sm:text-xs md:text-xs tracking-tighter  text-gray-600 leading-tight mt-1 px-2">
                {m.role}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* SECOND ROW - Centered Grid */}
      <div
        className="mt-6 sm:mt-8 md:mt-10 flex justify-center w-full"
        data-aos="fade-up"
        data-aos-delay="350"
      >
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 sm:gap-6 md:gap-5 max-w-4xl">
          {secondRow.map((m) => (
            <div key={m.name} className="flex flex-col items-center text-center">
              <div className="bg-white rounded-xl shadow-md overflow-hidden">
                <img
                  src={m.photo}
                  alt={m.name}
                  className="w-32 h-32 sm:w-36 sm:h-36 md:w-40 md:h-40 lg:w-44 lg:h-44 object-cover"
                />
              </div>

              <h2 className="text-xs sm:text-sm md:text-xs tracking-tighter  font-semibold text-gray-900 mt-3 leading-tight px-2">
                {m.name}
              </h2>

              <p className="text-xs sm:text-xs md:text-xs tracking-tighter  text-gray-600 leading-tight mt-1 px-2">
                {m.role}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* FOOTER TEXT */}
      <p 
        className="text-xs sm:text-sm md:text-base tracking-tighter  text-gray-700 text-center mt-10 sm:mt-12 md:mt-14 max-w-2xl px-4"
        data-aos="fade-up"
      >
        Innovation begins with people—and we're here to back every bold step.
      </p>

      {/* FOOTER CONTACT */}
<div
  className="mt-8 flex justify-center w-full"
  data-aos="fade-up"
  data-aos-delay="100"
>
  <div className="
      flex items-center gap-4 
      bg-white shadow-lg 
      px-6 py-3 
      rounded-full 
      text-gray-700 text-sm
    "
  >

    {/* Left Side Email */}
    <span className="text-gray-700 whitespace-nowrap text-xs">
      tbido@pup.edu.ph
    </span>

    {/* Divider */}
    <div className="w-px h-5 bg-gray-300"></div>

    {/* Right Side Copy */}
    <div
    onClick={handleCopy} 
    className="flex text-xs items-center gap-2 cursor-pointer hover:text-gray-900 transition">
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        width="16" 
        height="16" 
        fill="currentColor" 
        viewBox="0 0 24 24"
        className="text-gray-700"
      >
        <path d="M16 1H4C2.897 1 2 1.897 2 3v12h2V3h12V1z"/>
        <path d="M19 5H8C6.897 5 6 5.897 6 7v14c0 1.103.897 2 2 2h11c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2zm0 16H8V7h11v14z"/>
      </svg>

      <span>{copied ? "Copied!" : "Copy Email Address"}</span>
    </div>

  </div>
</div>

    </section>
  );
}